import type { Sortable } from '../types/next'

export const selectSortableMapSorted = <K extends string, V extends Sortable>(
  map?: Record<K, V>
): V[] => {
  return Object.values<V>(map ?? {}).sort(
    (a: V, b: V) => a.orderIndex - b.orderIndex
  )
}
